import { Component, OnInit, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Urls } from '../../../../utils/catalogue/urls';
import { ApiService } from '../../../../shared/catalogue/services/api.service';
import { CatalogService } from '@catalog/catalog.service';
import { DATA_PER_PAGE,
         Maximum_file_size_540kb,
         Please_upload_Image  } from '@root/app.constant';

const MAX_FILE_SIZE = 540000;

@Component({
  selector: 'app-key-features',
  templateUrl: './key-features.component.html',
  styleUrls: ['./key-features.component.scss'],
})
export class KeyFeaturesComponent implements OnInit {
  files: File[] = [];
  dataFile = 'Upload Image';
  userData: any = {};
  featureList = [];

  @Input() data: any[];

  pageSize: number = DATA_PER_PAGE;

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    private catalogService: CatalogService
  ) {}

  ngOnInit() {
    this.readAllKeyFeatures();
  }

  private readAllKeyFeatures() {
    this.catalogService.readAllKeyFeature().subscribe(
      (respose) => {
        this.data = respose.data.list;
      },
      (error) => {}
    );
  }

  incomingfile = (event) => {
    const fsize = event.target.files[0].size;
    const file = Math.round(fsize / 1024);
    if (fsize > MAX_FILE_SIZE) {
      this.toastr.error(Maximum_file_size_540kb );
      return;
    }
    if (!event.target.files[0]) {
      this.dataFile = 'Upload Image';
      this.files = null;
    } else {
      this.files = event.target.files[0];
      this.dataFile = event.target.files[0].name;
    }
  };

  proceesData = () => {
    if (this.files.length === 0) {
      this.toastr.error(Please_upload_Image);
    } else {
      let formData: any = new FormData();
      formData.append('file', this.files);
      formData.append('keyHeading', this.userData.feature);
      this.apiService
        .postData(Urls.uploadKeyFeature, formData)
        .subscribe((response: any) => {
          if (response.status === 0) {
            this.toastr.success('Key Feature Uploaded');
            this.resetData();
          } else {
            this.toastr.error('Please try again!', 'Something went wrong!');
          }
        });
    }
  };

  resetData = () => {
    this.files = null;
    this.dataFile = 'Upload Image';
  };

  viewFile = (path) => {
    window.open(path, '_blank');
  };
}
